// src/components/Admin/UserManager/UserDetailModal.jsx
import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    Box,
    Divider,
    Stack,
    Chip,
    ToggleButtonGroup,
    ToggleButton,
    useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PointManagePanel from './PointManagePanel';
import UserPointLogs from './UserPointLogs';

export default function UserDetailModal({ open, onClose, user, refreshUsers }) {
    const [tab, setTab] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            sx={{
                '& .MuiDialog-paper': {
                    width: '100%',
                    maxWidth: 700,
                    maxHeight: '90vh',
                    '@media (max-width:600px)': {
                        transform: 'scale(0.9)',
                        transformOrigin: 'top left',
                    },
                },
            }}
        >
            {/* ───── 헤더 ───── */}
            <DialogTitle>
                {user.nickname || user.username} — 상세 관리
            </DialogTitle>

            {/* 요약 Chip */}
            <Stack direction="row" spacing={1} sx={{ px: 3, pb: 1 }}>
                <Chip label={`${user.points.toLocaleString()} Leaf🌿`} size="small" />
                <Chip label={`권한 ${user.role}`} size="small" />
                <Chip
                    label={user.is_banned ? '정지 상태' : '정상'}
                    color={user.is_banned ? 'error' : 'success'}
                    size="small"
                />
            </Stack>

            {/* ───── 탭(토글) ───── */}
            <Box sx={{ px: 3, pb: 1 }}>
                <ToggleButtonGroup
                    exclusive
                    fullWidth
                    color="primary"
                    value={tab}
                    onChange={(_, v) => typeof v === 'number' && setTab(v)}
                    size={isMobile ? 'small' : 'medium'}
                >
                    <ToggleButton value={0} sx={{ flex: 1 }}>
                        {isMobile ? '💰 지급 / 회수' : '포인트 지급 / 회수'}
                    </ToggleButton>
                    <ToggleButton value={1} sx={{ flex: 1 }}>
                        {isMobile ? '📜 로그' : '포인트 로그'}
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>
            <Divider />

            {/* ───── 본문 ───── */}
            <Box
                sx={{
                    p: 3,
                    overflowY: 'auto',
                    maxHeight: 'calc(90vh - 170px)',
                    '@media (max-width:600px)': {
                        p: 2,
                        maxHeight: 'calc(90vh - 140px)',
                    },
                }}
            >
                {tab === 0 && (
                    <PointManagePanel
                        user={user}
                        onDone={refreshUsers}
                        onClose={onClose}
                    />
                )}
                {tab === 1 && (
                    <UserPointLogs userId={user.id} />
                )}
            </Box>
        </Dialog>
    );
}